import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { VideoComponentContext } from './video-context.interface';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.min.css'],
})
export class VideoComponent implements BuildingBlockInterface {
    @Input() public context: VideoComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/video/video.component.ts